import React, { useState, useEffect } from "react";
import axios from "axios";
import {Form, Input, InputNumber, Button, Row, Col} from "antd";
import dayjs from "dayjs";
import { Select } from "antd";
const { Option } = Select;


const initialNewItem = {
    ItemName: "",
    UOM: "",
    Rate: 0,
    Quantity: 1,
};

const initialEditItem = {
    ItemName: "",
    UOM: "",
    Rate: 0,
    Quantity: 1,
    Total: 0,
};

const { TextArea } = Input;
const DEFAULT_DESCRIPTION = `Dear Sir,
As per request please find the Quotation for accommodation. Below cost is excluding GST. Payment
terms will Be 15 Days once Invoice has been Raised. Aggregator Margin 2% Including if Owner Asked for
Advance or Deposit then Margin will be change Accordingly.`;


export default function Quotation() {
    const [antdForm] = Form.useForm();
    const [newItem, setNewItem] = useState(initialNewItem);
    const [customers, setCustomers] = useState([]);
    const [quotations, setQuotations] = useState([]);
    const [viewQuotation, setViewQuotation] = useState(null);
    const [editQuotation, setEditQuotation] = useState(null);

    const [filterCustomer, setFilterCustomer] = useState("");
    const [filterDateType, setFilterDateType] = useState("=");
    const [filterDate, setFilterDate] = useState("");

    // Get all unique quotation numbers
    const quotationNumberOptions = [...new Set(quotations.map(q => q.QuotationNumber).filter(Boolean))];
    // Filter state (multi-select for AntD Select)
    const [quotationNumberFilter, setQuotationNumberFilter] = useState([]); // or "" if single-select


    const customerNames = [...new Set(quotations.map(q => q.CustomerName).filter(Boolean))];
    const locations = [...new Set(quotations.map(q => q.Location).filter(Boolean))];

    useEffect(() => {
        axios.get("/customers").then(res => setCustomers(Array.isArray(res.data) ? res.data : []));
        loadQuotations();
    }, []);

    const loadQuotations = () => {
        axios.get("/quotation").then(res => setQuotations(Array.isArray(res.data) ? res.data : []));
    };

    // delete quotation, from Actions list
    const handleDeleteQuotation = (id) => {
        if (!window.confirm("Are you sure you want to delete this quotation?")) return;
        axios.delete(`/quotation/${id}`).then(() => {
            loadQuotations();
        });
    };

    const getValidTillDate = (date, validity) => {
        // date: String in "YYYY-MM-DD" or similar format
        // validity: Number of days
        if (!date || isNaN(validity)) return "";
        return dayjs(date).add(Number(validity || 0), "day").format("YYYY-MM-DD"); // or desired format
    };

    // Sort customers alphabetically by CustomerName only for Customer drop down field in Add Sales Invoice
    const sortedCustomers = [...customers].sort((a, b) =>
        a.CustomerName.localeCompare(b.CustomerName)
    );

    // Filtered quotations
    const filteredQuotations = quotations.filter(q => {
        if (filterCustomer && q.CustomerName !== filterCustomer) return false;
        if (quotationNumberFilter.length && !quotationNumberFilter.includes(q.QuotationNumber)) return false;
          if (filterDate) {
            const qDate = q.Date && q.Date.substr(0, 10);
            if (filterDateType === "=" && qDate !== filterDate) return false;
            if (filterDateType === "<" && qDate >= filterDate) return false;
            if (filterDateType === ">" && qDate <= filterDate) return false;
        }
        return true;
    });

    const resetFilters = () => {
        setFilterCustomer("");
        setQuotationNumberFilter([]);
        setFilterDateType("=");
        setFilterDate("");
        // Reset other filters here if you later add more (e.g., location, etc.)
    };



    // Add new item into Form.List 'Items'
    const handleAddNewItem = () => {
        if (!newItem.ItemName.trim()) {
            alert("Please enter item name");
            return;
        }
        if (newItem.Quantity < 1) {
            alert("Quantity must be at least 1");
            return;
        }
        const currentItems = antdForm.getFieldValue("Items") || [];
        const total = (Number(newItem.Rate) || 0) * (Number(newItem.Quantity) || 0);

        antdForm.setFieldsValue({
            Items: [...currentItems, { ...newItem, Total: total }],
        });
        setNewItem(initialNewItem);
    };

    // Submit Quotation form handler
    const onFinish = (values) => {
        if (!values.Items || values.Items.length === 0) {
            alert("Add at least one item before submitting.");
            return;
        }
        axios.post("/quotation", values).then(() => {
            antdForm.resetFields();
            setNewItem(initialNewItem);
            loadQuotations();
        });
    };


    // Edit Quotation Form
    function EditQuotationForm({ quotation, onClose, onSave }) {
        const [editForm] = Form.useForm();

        useEffect(() => {
            if (quotation) {
                editForm.setFieldsValue({
                    CustomerID: quotation.CustomerID || "",
                    Date: quotation.Date || new Date().toISOString().substr(0, 10),
                    Validity: quotation.Validity ?? 30,
                    Subject: quotation.Subject || "",
                    Description: quotation.Description || "",
                    Items: quotation.Items || [],
                });
            }
        }, [quotation, editForm]);

        const onEditFinish = (values) => {
            if (!values.Items || values.Items.length === 0) {
                alert("Add at least one item before saving.");
                return;
            }
            // Always recalculate Total for each item
            const itemsWithTotals = (values.Items || []).map(item => ({
                ...item,
                Rate: Number(item.Rate),
                Quantity: Number(item.Quantity),
                Total: Number(item.Rate) * Number(item.Quantity),
            }));

            // Send updated items to backend, always use itemsWithTotals
            axios.put(`/quotation/${quotation.QuotationID}`, {
                ...values,
                Items: itemsWithTotals,
            }).then(() => {
                onSave({ ...values, Items: itemsWithTotals });
            });
        };


        return (
            <div style={{border: "1px solid gray",padding: 20,background: "#FFF7F0",marginBottom: 20}}>
                <h3>Edit Quotation ID#{quotation.QuotationID}</h3>
                <Form form={editForm} onFinish={onEditFinish} layout="vertical">
                    <Form.Item
                        label="Customer"
                        name="CustomerID"
                        rules={[{ required: true, message: "Customer is required" }]}
                    >
                        <select style={{ width: "100%", padding: 6 }}>
                            {sortedCustomers.map(c => (
                                <option key={c.CustomerID} value={c.CustomerID}>{c.CustomerName}-{c.Location}</option>
                            ))}
                        </select>
                    </Form.Item>
                    {/* Date and Validity side by side in one row */}
                    <Row gutter={16}>
                        <Col span={5}>
                            <Form.Item label="Date" name="Date" rules={[{ required: true }]}>
                                <Input type="date" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                name="Validity"
                                label="Validity (days)"
                                initialValue={30}
                                rules={[{ required: true, message: "Please enter validity" }]}
                            >
                                <InputNumber min={1} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item label="Subject" name="Subject" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Description" name="Description">
                        <Input.TextArea rows={3} />
                    </Form.Item>

                    {/* Edit items table */}
                    <Form.List name="Items">
                        {(fields, { remove }) => (
                            <table border={1} cellPadding={5} style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
                                <thead style={{ backgroundColor: "#fff", fontWeight: "bold" }}>
                                <tr>
                                    <th>Sr</th>
                                    <th>Item Name</th>
                                    <th>UOM</th>
                                    <th>Rate</th>
                                    <th>Quantity</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {fields.length === 0 ? (
                                    <tr>
                                        <td colSpan={7} style={{ textAlign: "center", color: "#999" }}>
                                            No items added
                                        </td>
                                    </tr>
                                ) : fields.map(({ key, name, ...restField }, index) => (
                                    <tr key={key}>
                                        <td>{index + 1}</td>
                                        <td>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "ItemName"]}
                                                rules={[{ required: true, message: "Missing item name" }]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </td>
                                        <td>
                                            <Form.Item {...restField} name={[name, "UOM"]} style={{ marginBottom: 0 }}>
                                                <Input />
                                            </Form.Item>
                                        </td>
                                        <td>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "Rate"]}
                                                rules={[{ required: true, message: "Missing rate" }]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber min={0} style={{ width: "100%" }} />
                                            </Form.Item>
                                        </td>
                                        <td>
                                            <Form.Item
                                                {...restField}
                                                name={[name, "Quantity"]}
                                                rules={[
                                                    { required: true, message: "Missing quantity" },
                                                    { type: "number", min: 1, message: "Quantity must be at least 1" },
                                                ]}
                                                style={{ marginBottom: 0 }}
                                            >
                                                <InputNumber min={1} style={{ width: "100%" }} />
                                            </Form.Item>
                                        </td>
                                        <td>
                                            <Form.Item shouldUpdate noStyle>
                                                {({ getFieldValue }) => {
                                                    const rate = getFieldValue(["Items", name, "Rate"]) || 0;
                                                    const qty = getFieldValue(["Items", name, "Quantity"]) || 0;
                                                    return <span>{(rate * qty).toFixed(2)}</span>;
                                                }}
                                            </Form.Item>
                                        </td>
                                        <td>
                                            <Button  onClick={() => remove(name)}>
                                                Delete
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        )}
                    </Form.List>

                    <Form.Item>
                        <Button type="default" htmlType="submit" style={{ fontSize: "1.2em" }}>
                            Save
                        </Button>
                        <Button type="default" onClick={onClose} style={{ marginLeft: 8 }}>Cancel</Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }

    return (
        <div style={{border: "1px solid gray",padding: 20,background: "#fff",marginBottom: 20}}>
            {/* New Quotation Form */}
            <div
                style={{
                    backgroundColor: "aliceblue",
                    border: "1px solid grey",
                    borderRadius: 6,
                    padding: 20,
                    marginBottom: 40,
                }}
            >
                <h3 style={{ marginBottom: 16 }}>Add Quotation</h3>
                <Form
                    form={antdForm}
                    layout="vertical"
                    initialValues={{ Description: DEFAULT_DESCRIPTION,Validity: 30 , Date: new Date().toISOString().substr(0, 10), Items: [] }}
                    onFinish={onFinish}
                >
                    {/* Customer Selector */}
                    <Form.Item
                        label="Customer"
                        name="CustomerID"
                        rules={[{ required: true, message: "Customer is required" }]}
                    >
                        <select style={{ width: "100%", padding: 6 }}>
                            <option value="">-- Select Customer --</option>
                            {sortedCustomers.map(c => (
                                <option key={c.CustomerID} value={c.CustomerID}>{c.CustomerName} - {c.Location}</option>
                            ))}
                        </select>
                    </Form.Item>
                    {/* Date and Validity side by side in one row */}
                    <Row gutter={16}>
                        <Col span={5}>
                            <Form.Item label="Date" name="Date" rules={[{ required: true }]}>
                                <Input type="date" />
                            </Form.Item>
                        </Col>
                        <Col span={4}>
                            <Form.Item
                                name="Validity"
                                label="Validity (days)"
                                initialValue={30}
                                rules={[{ required: true, message: "Please enter validity" }]}
                            >
                                <InputNumber min={1} style={{ width: "100%" }} />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* Subject */}
                    <Form.Item
                        label="Subject"
                        name="Subject"
                        rules={[{ required: true, message: "Subject is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    {/* Description */}
                    <Form.Item label="Description" name="Description"
                               rules={[{ required: true, message: "Description is required" }]}
                    >
                        <Input.TextArea rows={4} />
                    </Form.Item>

                    {/* New Item Inputs */}
                    <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
                        Item:
                        <Input
                            placeholder="Item Name"
                            value={newItem.ItemName}
                            onChange={e => setNewItem({ ...newItem, ItemName: e.target.value })}
                            style={{ flex: 3 }}
                        />
                        UOM:
                         <Input
                            placeholder="UOM"
                            value={newItem.UOM}
                            onChange={e => setNewItem({ ...newItem, UOM: e.target.value })}
                            style={{ flex: 1 }}
                        />
                        Rate:
                        <InputNumber
                            min={0}
                            placeholder="Rate"
                            value={newItem.Rate}
                            onChange={val => setNewItem({ ...newItem, Rate: val })}
                        />
                        QTY:
                        <InputNumber
                            min={1}
                            placeholder="Quantity"
                            value={newItem.Quantity}
                            onChange={val => setNewItem({ ...newItem, Quantity: val })}
                        />
                        <Button type="default" onClick={handleAddNewItem}>
                            Add Row
                        </Button>
                    </div>

                    {/* Items Editable Table */}
                    <Form.List name="Items">
                        {(fields, { remove }) => (
                            <table border={1} cellPadding={5} style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
                                <thead style={{ backgroundColor: "#fff", fontWeight: "bold" }}>
                                <tr>
                                    <th>Sr</th>
                                    <th>Item Name</th>
                                    <th>UOM</th>
                                    <th>Rate</th>
                                    <th>Quantity</th>
                                    <th>Total</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {fields.length === 0 ? (
                                    <tr><td colSpan={7} style={{ textAlign: "center", color: "#999" }}>No items added</td></tr>
                                ) : (
                                    fields.map(({ key, name, ...restField }, index) => (
                                        <tr key={key}>
                                            <td>{index + 1}</td>
                                            <td><Form.Item {...restField} name={[name, "ItemName"]} rules={[{ required: true }]} style={{ marginBottom: 0 }}><Input /></Form.Item></td>
                                            <td><Form.Item {...restField} name={[name, "UOM"]} style={{ marginBottom: 0 }}><Input /></Form.Item></td>
                                            <td><Form.Item {...restField} name={[name, "Rate"]} rules={[{ required: true }]} style={{ marginBottom: 0 }}><InputNumber min={0} style={{ width: "100%" }} /></Form.Item></td>
                                            <td><Form.Item {...restField} name={[name, "Quantity"]} rules={[{ required: true, type: "number", min: 1 }]} style={{ marginBottom: 0 }}><InputNumber min={1} style={{ width: "100%" }} /></Form.Item></td>
                                            <td>
                                                <Form.Item shouldUpdate noStyle>
                                                    {({ getFieldValue }) => {
                                                        const rate = getFieldValue(["Items", name, "Rate"]) || 0;
                                                        const qty = getFieldValue(["Items", name, "Quantity"]) || 0;
                                                        return <span>{(rate * qty).toFixed(2)}</span>;
                                                    }}
                                                </Form.Item>
                                            </td>
                                            <td>
                                                <Button danger onClick={() => remove(name)}>Delete</Button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                                </tbody>
                            </table>
                        )}
                    </Form.List>

                    <Form.Item>
                        <Button type="default" htmlType="submit" style={{ fontWeight: "bold", fontSize: "1em" }}>
                            Save Quotation
                        </Button>
                    </Form.Item>
                </Form>
            </div>

            {/* -------- Filters + Quotation List -------- */}
            <div
                style={{
                    background: "#FFFFEB",
                    border: "1px solid #beaedc",
                    padding: 18,
                    borderRadius: 6,
                }}
            >
                <h3>Quotation List</h3>
                <div style={{ display: "flex", alignItems: "center", gap: 24, flexWrap: "wrap" }}>
                    {/* Quotation Number Filter */}
                    <label style={{ display: "flex", alignItems: "center" }}>
                        Quotation #:
                        <Select
                            showSearch
                            mode="multiple"
                            allowClear
                            placeholder="Quotation Number"
                            style={{ marginLeft: 8, minWidth: 140 }}
                            value={quotationNumberFilter.length ? quotationNumberFilter : undefined}
                            onChange={setQuotationNumberFilter}
                            filterOption={(input, option) =>
                                option.children &&
                                option.children.toLowerCase().startsWith(input.toLowerCase())
                            }
                        >
                            {quotationNumberOptions.map(num => (
                                <Option key={num} value={num}>{num}</Option>
                            ))}
                        </Select>
                    </label>
                    <label style={{ display: "flex", alignItems: "center" }}>
                        Customer:
                        <select
                            value={filterCustomer}
                            onChange={e => setFilterCustomer(e.target.value)}
                            style={{ marginLeft: 8, minWidth: 140 }}
                        >
                            <option value="">All customers</option>
                            {customerNames.map(cust => (
                                <option key={cust} value={cust}>
                                    {cust}
                                </option>
                            ))}
                        </select>
                    </label>
                    <label>
                        Date:
                        <select
                            value={filterDateType}
                            onChange={e => setFilterDateType(e.target.value)}
                            style={{ marginLeft: 8, width: 60 }}
                        >
                            <option value="=">=</option>
                            <option value="<">&lt;</option>
                            <option value=">">&gt;</option>
                        </select>
                        <input
                            type="date"
                            value={filterDate}
                            onChange={e => setFilterDate(e.target.value)}
                            style={{ marginLeft: 8, width: 150 }}
                        />
                    </label>
                    <button
                        type="button"
                        onClick={() => {
                            setFilterCustomer("");
                            setFilterDateType("=");
                            setFilterDate("");
                        }}
                        style={{ padding: "6px 16px" }}
                    >
                        Clear Filters
                    </button>
                </div>

                    <table
                    border={1}
                    cellPadding={6}
                    width="100%"
                    style={{ borderCollapse: "collapse", fontSize: 14 }}
                >
                    <thead style={{ backgroundColor: "#fff" }}>
                    <tr>
                        <th>Quotation#</th>
                        <th>Customer</th>
                        <th>Location</th>
                        <th>Date</th>
                        <th>Validity</th>
                        <th>Subject</th>
                        <th>Description</th>
                        <th># Items</th>
                        <th> Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredQuotations.length === 0 ? (
                        <tr>
                            <td colSpan={7} style={{ textAlign: "center", color: "#999" }}>
                                No quotations found
                            </td>
                        </tr>
                    ) : (
                        filteredQuotations.map(q => (
                            <tr key={q.QuotationID}>
                                <td>{q.QuotationNumber}</td>
                                <td>{q.CustomerName}</td>
                                <td>{q.Location || "-"}</td>
                                <td>{q.Date}</td>
                                <td>{q.Validity}</td>
                                <td>{q.Subject}</td>
                                <td>{q.Description}</td>
                                <td>{q.Items?.length || 0}</td>
                                <td>
                                    <button
                                        onClick={() => setViewQuotation(q)}
                                        style={{ marginRight: 8, backgroundColor: "lightgrey", color: "black", border: "none", padding: "5px 10px", borderRadius: "3px", cursor: "pointer" }}
                                    >
                                        View
                                    </button>
                                    <button
                                        onClick={() => setEditQuotation(q)}
                                        style={{ marginRight: 8, backgroundColor: "lightgrey", color: "black", border: "none", padding: "5px 10px", borderRadius: "3px", cursor: "pointer" }}
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => handleDeleteQuotation(q.QuotationID)}
                                        style={{ marginRight: 8, backgroundColor: "lightgrey", color: "black", border: "none", padding: "5px 10px", borderRadius: "3px", cursor: "pointer" }}
                                    >
                                        Delete
                                    </button>
                                    <button
                                        onClick={() => window.open(`/quotation/${q.QuotationID}/pdf`, "_blank")}
                                        style={{ marginRight: 8, backgroundColor: "lightgrey", color: "black", border: "none", padding: "5px 10px", borderRadius: "3px", cursor: "pointer" }}
                                    >
                                        PDF
                                    </button>
                                </td>

                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>


            {/* View Quotation Details */}
            {viewQuotation && (
                <div style={{border: "1px solid gray",padding: 20,background: "#F4FFF0",marginBottom: 20}}>
                    <h3>Quotation Details ID#{viewQuotation.QuotationNumber}</h3>
                    <div><b>Customer:</b> {viewQuotation.CustomerName}</div>
                    <div><b>Location:</b> {viewQuotation.Location}</div>
                    <div><b>Date:</b> {viewQuotation.Date}</div>
                    <div><b>Valid Till:</b> {getValidTillDate(viewQuotation.Date, viewQuotation.Validity)}</div>
                    <div><b>Subject:</b> {viewQuotation.Subject}</div>
                    <div><b>Description:</b> {viewQuotation.Description}</div>
                    <h4>Items</h4>
                    <table border={1} cellPadding={4} style={{ width: "100%" }}>
                        <thead>
                        <tr>
                            <th>Sr</th><th>Item Name</th><th>UOM</th><th>Rate</th><th>Quantity</th><th>Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        {viewQuotation.Items.map((item, idx) => (
                            <tr key={idx}>
                                <td>{idx + 1}</td><td>{item.ItemName}</td><td>{item.UOM}</td><td>{item.Rate}</td><td>{item.Quantity}</td><td>{item.Total.toFixed(2)}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <button onClick={() => setViewQuotation(null)}
                            style={{ marginRight: 8, backgroundColor: "lightgrey", color: "black", border: "none", padding: "5px 10px", borderRadius: "3px", cursor: "pointer" }}
                    >
                        Close
                    </button>
                    <button
                        onClick={() => window.open(`/quotation/${viewQuotation.QuotationID}/pdf`, "_blank")}
                        style={{ marginRight: 8, backgroundColor: "lightgrey", color: "black", border: "none", padding: "5px 10px", borderRadius: "3px", cursor: "pointer" }}

                    >
                        PDF
                    </button>
                </div>
            )}

            {/* Edit Quotation Modal */}
            {editQuotation && (
                <EditQuotationForm
                    quotation={editQuotation}
                    onClose={() => setEditQuotation(null)}
                    onSave={() => {
                        loadQuotations();
                        setEditQuotation(null);
                        setViewQuotation(null);
                    }}
                />
            )}
        </div>
    );
}
